import { Injectable } from '@angular/core';
import { MyProfileApi } from '../../shared/api.url';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../../shared/models/api.response';
import { ChangePasswordModel } from './myprofile.model';
import { environment } from 'environments/environment';
import { BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'  // Make sure the service is available application-wide
})
export class MyProfileService {
  apiUrl = environment.apiBaseUrl;
  private messageSource = new BehaviorSubject<string>(''); // Initial empty message
  profilePic = this.messageSource.asObservable(); // Observable to listen to changes

  constructor(public http: HttpClient) { }

  // Method to send the message
  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  changePassword(model: any) {
    return this.http.post<ApiResponse>(this.apiUrl +MyProfileApi.changePasswordApiUrl, model);
  }

  editProfile(model: any) {
    return this.http.post<ApiResponse>(this.apiUrl +MyProfileApi.editProfileApiUrl, model);
  }


  getUser() {
    return this.http.get<ApiResponse>(this.apiUrl +MyProfileApi.getloggedInUserDetailApiUrl);
  }

  updateProfilePicture(model) {
    return this.http.post<ApiResponse>(this.apiUrl +MyProfileApi.updateProfilePictureApiUrl, model);
  }

}
